module.exports = __webpack_public_path__ + "static/media/IMG-1.ff09e402.jpg";